import { render, staticRenderFns } from "./appointment-messages.vue?vue&type=template&id=05f941f9"
import script from "./appointment-messages.vue?vue&type=script&lang=js"
export * from "./appointment-messages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports